var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChatSolid = function SvgChatSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#fff",
    viewBox: "0 0 30 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M13.56.102h2.828C23.42.102 29.12 5.61 29.12 12.406c0 6.795-5.7 12.304-12.73 12.304H6.485c-3.125 0-5.658-2.448-5.658-5.469v-6.835C.828 5.61 6.528.102 13.56.102M9.314 16.165c-.585 0-1.06-.459-1.06-1.025s.474-1.025 1.06-1.025h5.659c.586 0 1.06.459 1.06 1.025s-.474 1.025-1.06 1.025zm0-5.468c-.585 0-1.06-.46-1.06-1.026s.474-1.025 1.06-1.025h11.317c.586 0 1.06.46 1.06 1.025 0 .567-.474 1.026-1.06 1.026z",
    clipRule: "evenodd"
  })));
};
export default SvgChatSolid;